import { AsyncPipe, NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { Tag } from 'primeng/tag'

import { FLEET_CUSTOM_ROLE_ID_RANGE, TI_CUSTOM_ROLE_ID_RANGE } from '@ti/contracts'
import { selectState } from '@ti/core/common/utils'
import { FileSearchIconComponent } from '@ti/core/icons/file-search'
import { NoSearchIconComponent } from '@ti/core/icons/no-search'
import { DataGridComponent } from '@ti/core/ui-kit/layout/components/data-grid'

import { BaseRolesListModel } from '../../models'

@Component({
  selector: 'app-role-management-grid',
  templateUrl: 'role-management-grid.component.html',
  styleUrls: ['role-management-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    DataGridComponent,
    FileSearchIconComponent,
    NgClass,
    NoSearchIconComponent,
    Tag,
    TranslatePipe,
  ],
})
export class RoleManagementGridComponent {
  protected readonly model = inject(BaseRolesListModel)
  protected readonly state = selectState(BaseRolesListModel)

  protected readonly TYPES = { TI_CUSTOM_ROLE_ID_RANGE, FLEET_CUSTOM_ROLE_ID_RANGE }
}
